import UIkit from 'uikit'

let switcherConfiguration = {
    /**
     * Component name
     * @type {String}
     */
    name: 'tab-switcher',

    /**
     * Component
     */
    $component: {},

    /** Data
     * @type {Object}
     */
    $data: { switcher: {} },

    /**
     * Create components
     * @vois
     */
    init () {
        console.log('SWITCHER Initialized')

        this.$component = document.querySelector(`.${this.name}`)

        this.buildSwitcher()
        this.attachEventsHandlers()
    },

    /**
     * Attach event handlers
     */
    attachEventsHandlers () {
        const SWITCHER_TAB = document.querySelector('.tab-switcher-content')

        if (SWITCHER_TAB instanceof HTMLElement) {
            SWITCHER_TAB.addEventListener(
                'show',
                () => {
                    console.log('show switcher')
                }
            )
        }
    },

    buildSwitcher () {
        this.$data.switcher = UIkit.switcher(
            this.$component,
            {
                connect: '.tab-switcher-content',
                cls: 'is-active'
            }
        )
    }
}

export default switcherConfiguration
